module.exports = __webpack_public_path__ + "static/media/blog-toplu-mms.5a528128.jpg";